function Banner(props) {
    const banner = props.banner;
    return(
        <div className="banner" >
            <div className="bannerBg" style={{'backgroundImage': "url("+banner.image+")"}}/>
            <div className="bannerContent">
                <div className="bannerContentLeft">
                    <h1 className="bannerTitle">{banner.title}</h1>
                    <p className="bannerSubtitle">{banner.details}</p>
                </div>
                <div className="bannerContentRight">
                    <h3>USE CODE: </h3>
                    <button className="btn btn-getStarted">{banner.code}</button>
                </div>
            </div>
        </div>
    );
}
export default Banner;